import type { CancellationPolicyResponse } from '@bookingkit/api-v4/dist/models';
import { CancellationPoliciesServiceError } from '../Errors/CancellationPoliciesServiceError';
import type { AttachedCancellationPolicy } from '../types';

export type { AttachedCancellationPolicy };

export const fromApiModel = (policy: CancellationPolicyResponse): AttachedCancellationPolicy => {
    if (typeof policy.id !== 'string') {
        throw CancellationPoliciesServiceError.fromInvalidProperty('id', 'string', policy.id);
    }
    if (typeof policy.name !== 'string') {
        throw CancellationPoliciesServiceError.fromInvalidProperty('name', 'string', policy.name);
    }
    return {
        id: policy.id,
        name: policy.name,
    };
};
